import { createAction } from '@reduxjs/toolkit';
import { name } from './slice';

export const submitCertificateAction = createAction(
  `${name}/SUBMIT_CERTIFICATE_FORM`,
);

export const createCertificateAction = createAction(
  `${name}/CREATE_CERTIFICATE`,
);

export const createCertificateSuccessAction = createAction(
  `${name}/CREATE_CERTIFICATE_SUCCESS`,
);

export const createCertificateFailedAction = createAction<unknown>(
  `${name}/CREATE_CERTIFICATE_FAILED`,
);

export const downloadCertificateAction = createAction<unknown>(
  `${name}/DOWNLOAD_CERTIFICATE`,
);

export const downloadCertificateSuccessAction = createAction<unknown>(
  `${name}/DOWNLOAD_CERTIFICATE_SUCCESS`,
);

export const downloadCertificateFailedAction = createAction<unknown>(
  `${name}/DOWNLOAD_CERTIFICATE_FAILED`,
);
